import { useEffect } from 'react';

import { usePaymentItemDetails } from '../../../../fetchHooks/usePaymentItems';
import { TransferAction, TransferActionType } from '../form/actions';

const useSetNotesInfo = (futurePaymentId: string, handleChange: (action: TransferAction) => void) => {
    const { data: futurePaymentDetails } = usePaymentItemDetails({ value: futurePaymentId });

    useEffect(() => {
        if (futurePaymentDetails?.ownText) {
            handleChange({
                type: TransferActionType.OWN_TEXT,
                payload: futurePaymentDetails.ownText,
            });
        }

        if (futurePaymentDetails?.note) {
            handleChange({
                type: TransferActionType.NOTE,
                payload: futurePaymentDetails.note,
            });
        }
    }, [futurePaymentDetails, handleChange]);

    return {
        ownText: futurePaymentDetails?.ownText,
        receiverText: futurePaymentDetails?.note,
    };
};

export default useSetNotesInfo;
